export enum ExportTypeEnum {
  PDF = 'PDF',
  XLSX = 'XLSX',
  CSV = 'CSV',
  DOCX = 'DOCX'
}
